import { createFileRoute, Link } from "@tanstack/react-router";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import content from "../../PRIVACY_POLICY.md?raw";
import styles from "./blog/blog.module.css";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy - Site Spy" },
      {
        name: "description",
        content: "Privacy Policy for Site Spy browser extension",
      },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <main className={styles.main}>
      <div className={styles.bgGradient} />

      <header className={styles.header}>
        <Link to="/" className={styles.backLink}>
          &larr; Site Spy
        </Link>
      </header>

      <article className={styles.article}>
        <div className={styles.content}>
          <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
        </div>
      </article>

      <footer className={styles.footer}>
        <Link to="/">Home</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/refund">Refund Policy</Link>
        <Link to="/dashboard/support">Support</Link>
      </footer>
    </main>
  );
}
